document.getElementById('registroForm').addEventListener('submit', function enviarFormulario(e) {
  e.preventDefault();

  const form = e.target;
  const formData = new FormData(form);
  const mensajeDiv = document.getElementById('mensaje');
  const loader = document.getElementById('loader');

  // Mostrar loader
  loader.style.display = 'flex';

  // Resetear mensaje
  mensajeDiv.classList.remove('show');
  mensajeDiv.style.display = 'none';
  mensajeDiv.textContent = '';

  fetch('https://merca3w.com/zebra/registrar.php', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    loader.style.display = 'none'; // Ocultar loader

    mensajeDiv.style.backgroundColor = data.success ? '#d4edda' : '#f8d7da';
    mensajeDiv.style.color = data.success ? '#155724' : '#721c24';
    //mensajeDiv.style.border = 1px solid ${data.success ? '#c3e6cb' : '#f5c6cb'};
    mensajeDiv.textContent = data.message;
    mensajeDiv.style.display = 'block';
    setTimeout(() => mensajeDiv.classList.add('show'), 10);

    //if (data.success) form.reset();
    if (data.success) {
      form.reset();
      setTimeout(() => {
        window.location.href = 'https://promocioneszebra.mx/pages/gracias-por-registrarte';
      }, 2000); // Redirige después de 2 segundos
    }

    setTimeout(() => {
      mensajeDiv.classList.remove('show');
      setTimeout(() => mensajeDiv.style.display = 'none', 500);
    }, 6000);
  })
  .catch(error => {
    loader.style.display = 'none'; // Ocultar loader en error también
    mensajeDiv.style.backgroundColor = '#f8d7da';
    mensajeDiv.style.color = '#721c24';
    mensajeDiv.style.border = '1px solid #f5c6cb';
    mensajeDiv.textContent = 'Error de conexión. Intenta más tarde.';
    mensajeDiv.style.display = 'block';
    setTimeout(() => mensajeDiv.classList.add('show'), 10);
    console.error(error);
  });
});